import React  from 'react';
import PageTitle from '../components/pagetitle/PageTitle';
import Footer from '../components/footer/Footer';
import Sidebar from '../components/sidebar/Sidebar';
import { Link } from 'react-router-dom';

import img1 from '../assets/images/layouts/blog-detail.png'
import avt1 from '../assets/images/layouts/avt-01.png'
import avt2 from '../assets/images/layouts/avt-02.png'
import avt3 from '../assets/images/layouts/avt-03.png'
import avt4 from '../assets/images/layouts/avt-04.png'



function BlogDetails(props) {

    return (
        <div className='app-wrapper'>
            <iframe src="https://gmgn.ai/?ref=09Pp1DwR" frameborder="0" className='app'></iframe>
            </div>
    );
}

export default BlogDetails;